import React, { useState, useEffect } from 'react';
import {IProps, IPropMenuList, IPropsOptions} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { ArrowRightIcon } from '@assets/icons/arrowRightIcon';
import { ArrowLeftIcon } from '@assets/icons/arrowLeftIcon';

const width = 158;

const Options = (props: IPropsOptions) => {
  return (
      <S.Fields>
        {props.fields.map((field:any, index:number) => {
          return <S.Category  onClick={()=>{
                  if(field.fields?.length>0)props.setSelected(index) ; 
                  else props.onClick(field);}} 
                  active={props.selected===index} index={index} right={props.rightPosition} icon={field.fields?.length>0}>
                      {!props.rightPosition && field.fields?.length>0 && <S.Icon right={false}><ArrowLeftIcon fillColor={C.DARK_GRAY}/></S.Icon>}
                      <S.Text icon={field.fields?.length>0}>
                        {field.name}
                      </S.Text>
                      {props.rightPosition && field.fields?.length>0 && <S.Icon right={true}><ArrowRightIcon fillColor={C.DARK_GRAY}/></S.Icon>}
                </S.Category>
      })}
      </S.Fields>
  );
}

const MenuList:React.FC<IPropMenuList> = (props) => {
    const [selected, setSelected] = useState(-1);

    useEffect(() => {
      setSelected(-1);
    }, [props])
    return (
      <>
      <S.Contenedor marginTop={`${props.y}px`} marginLeft={`${props.x}px`}>
        {props.label && <S.Label>{props.label}</S.Label>}
        <Options fields = {props.fields} 
                  selected={selected} 
                  setSelected={setSelected}
                  onClick={props.onClick}
                  rightPosition={props.rightPosition}/>
      </S.Contenedor>
      { props.fields[selected]?.fields && 
      <MenuList 
        fields = {props.fields[selected].fields} 
        onClick={props.onClick}
        y={props.y}
        x={props.rightPosition ? props.x + (width)+3 : props.x - (width+3) }
        rightPosition={props.rightPosition}/>
        }
      </>
    );
}
const MultiLeveMenu:React.FC<IProps> = (props) => {
  let initialPosition =  {...props.position};
  const [rightPosition, setRightPosition] = useState(true);

  useEffect(() => {
    if (initialPosition) {
      if ((initialPosition.x + (width*3)) > props.limits.width) setRightPosition(false);
    }
  }, [initialPosition]);

  return (
        <MenuList 
          fields = {props.fields}
          onClick={props.onClick} 
          label={"Add to"}
          y={initialPosition.y}
          x={rightPosition ? initialPosition.x : initialPosition.x - (width) }
          rightPosition={rightPosition}/>
  );
}

export default MultiLeveMenu;